export const isDev = window.location.href.includes("localhost");
